/**
 * @description 主机地图 hostMapping
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const hostMappingBiz = new Logic()

hostMappingBiz.searchChartData = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.kpi.getHostChartData,
    data: data
  })
}

hostMappingBiz.getSiteMap = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.hostMapping.getSiteMap,
    data: data
  })
}

hostMappingBiz.getRegionMap = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.hostMapping.getRegionMap,
    data: data
  })
}

hostMappingBiz.getModule = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.hostMapping.getModule,
    data: {
      department: data.department,
      siteCode: data.siteCode
    }
  })
}

export default hostMappingBiz
